import Vue from "vue";
import VueRouter from "vue-router";
import Schedule from "../views/schedule/Schedule.vue";
import Completion from "../views/completion/Completion.vue";
import Detail from "../views/detail/Detail.vue";
import Write from "../views/write/Write.vue";
import Setting from "../views/setting/Setting.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "schedule",
    },
  },
  {
    path: "/supply",
    redirect: {
      name: "schedule",
    },
  },
  {
    path: "/supply/schedule",
    name: "schedule",
    component: Schedule,
  },
  {
    path: "/supply/completion",
    name: "completion",
    component: Completion,
  },
  {
    path: "/supply/detail",
    name: "detail",
    component: Detail,
  },
  {
    path: "/supply/write",
    name: "write",
    component: Write,
  },
  {
    path: "/supply/setting",
    name: "setting",
    component: Setting,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// NavigationDuplicated 오류 방지
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err;
    }
    return Promise.reject(err);
  });
};

export default router;
